import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'projects/packcert-web/src/environments/environment';

@Injectable()

export class CsvImportService {
    constructor(
        private readonly _http: HttpClient,
        private _translate: TranslateService
    ) {}

    public getCsvSpecificationDoc(screenUrl: string, filters: any) {
        return this._http.post<any>(environment.apiEndpoint + screenUrl + '/GetCsvHelpDocument', filters);
    }

    public getCsvTemplate(screenUrl, filters) {
        return this._http.post<any>(environment.apiEndpoint + screenUrl + '/GetCsvDataTemplate', filters);
    }

    public getFilterableListTitles(keyword) {
        const columnTitles: Array<any> = [];
        let id = 1;

        this._translate
        .get(`csv-import.keywords.${keyword}.columnTitles`)
        .subscribe(res => {
            Object.keys(res).forEach(key => {
            const value = res[key];
            columnTitles.push({ des: value, id: id });
            id += 1;
            });
        });

        return columnTitles;
    }

    /**
     * LLamadas reutilizables de primera importación, posteriores validaciones e inserción en BD
     * @param screenUrl /ParteDelEndpointParaLaPantalla
     */
    public importCsvTemporarily(screenUrl, filters) {
        return this._http.post<any>(environment.apiEndpoint + screenUrl + '/ImportDataByCsv', filters);
    }

    public correctCsv(screenUrl, filters) {
        return this._http.post<any>(environment.apiEndpoint + screenUrl + '/CorrectCsvData', filters);
    }

    public insertCsv(screenUrl, filters) {
        return this._http.post<any>(environment.apiEndpoint + screenUrl + '/InsertUpdateCsvDataToDb', filters);
    }
}